import tw from 'tailwind-styled-components'

export const StatisticsWrapper = tw.div`
  flex flex-col w-full rounded-7 bg-['#17181b']
`

export const StatisticsGrid = tw.div`
    grid grid-cols-2 gap-30 place-content-center md:grid-flow-col md:grid-cols-4 bg-eerieBlackLight border-borderGray border-solid border p-30 rounded-md
`